import { render, staticRenderFns } from "./CityChatDock.vue?vue&type=template&id=5d272206&scoped=true"
import script from "./CityChatDock.vue?vue&type=script&lang=js"
export * from "./CityChatDock.vue?vue&type=script&lang=js"
import style0 from "./CityChatDock.vue?vue&type=style&index=0&id=5d272206&prod&lang=css"
import style1 from "./CityChatDock.vue?vue&type=style&index=1&id=5d272206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d272206",
  null
  
)

export default component.exports